export default ({ username, type }: { username: string, type: "instagram" | "something" }): string => {
  switch (type) {
    case "instagram" :
      return `https://www.instagram.com/${username}`;
    
    default:
      return "https://www.instagram.com";
  }
}